<!-- Admin-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>Edit User Rights</cs-header-title>
  <cs-header-content>
    <cs-label>{{ email }}</cs-label>
  </cs-header-content>
</cs-header>

<cs-content [loading]="loading">
  <cs-item-list>
    @if (searching) {
      <cs-spinner></cs-spinner>
    }
    @if (!searching && error != '') {
      <cs-item>
        <cs-label>{{ error }}</cs-label>
      </cs-item>
    }

    @if (!searching && error == '' && email != '' && email != null) {
      <cs-item-list-header>User role</cs-item-list-header>
      <cs-radio-group [(selected)]="role">
        @for (d of authRoleDescriptions; track d) {
          <cs-radio [value]="d.value">
            {{ d.name }}
            <cs-note>{{ d.adminExplanation }}</cs-note>
          </cs-radio>
        }
      </cs-radio-group>
    }
  </cs-item-list>
</cs-content>

<cs-page-action-buttons [showCancel]="true" (cancel)="handleCancelButtonClicked($event)">
  <cs-button primary medium [label]="'Apply' | untranslated" [disabled]="!hasChanges()" (click)="handleApplyButtonClicked($event)"></cs-button>
</cs-page-action-buttons>